var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.576 118.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    cx: 50.001,
    cy: 50,
    r: 50,
    fill: "#c9c4be"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "25.001 93.303 33.505 89.209 37.843 89.157 40.198 85.077 50.001 98.881 59.803 85.077 62.158 89.157 66.496 89.208 75.001 93.303 75.708 83.891 77.833 80.105 75.479 76.027 92.334 74.439 85.279 59.05 89.99 59.05 92.203 55.318 100 50 92.203 44.681 89.99 40.95 85.279 40.95 92.333 25.559 75.479 23.973 77.833 19.893 75.707 16.111 75 6.699 66.496 10.792 62.158 10.843 59.803 14.922 50 1.118 40.198 14.922 37.843 10.843 33.505 10.792 25 6.699 24.293 16.111 22.168 19.893 24.523 23.973 7.667 25.56 14.722 40.95 10.011 40.95 7.798 44.682 0 50 7.797 55.318 10.011 59.05 14.722 59.05 7.668 74.441 24.523 76.027 22.168 80.105 24.293 83.889",
    fill: "#0d0f0f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "68.609 86.282 72.116 84.258 72.116 80.212 68.609 78.188 55.088 52.938 83.717 52.023 87.223 54.048 90.727 52.025 90.727 47.976 87.223 45.953 83.717 47.976 55.088 47.063 68.611 21.813 72.117 19.789 72.117 15.743 68.611 13.719 65.107 15.742 65.105 19.789 50.001 44.125 34.896 19.789 34.895 15.741 31.392 13.718 27.885 15.743 27.885 19.789 31.391 21.813 44.913 47.063 16.285 47.976 12.778 45.953 9.275 47.975 9.275 52.023 12.778 54.047 16.285 52.023 44.913 52.938 31.39 78.188 27.885 80.211 27.884 84.258 31.39 86.281 34.895 84.258 34.895 80.211 50 55.875 65.105 80.211 65.105 84.259"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "57.051 22.393 50.001 34.681 42.951 22.393 50.001 10.104"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "29.617 30.09 36.734 42.34 22.567 42.301 15.45 30.052"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "22.566 57.697 36.733 57.659 29.616 69.908 15.449 69.947"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "42.949 77.607 50 65.318 57.05 77.607 50 89.896"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "70.384 69.91 63.268 57.66 77.434 57.699 84.551 69.947"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(5.9999 0 0 6 70.576 -118.21)",
    points: "77.436 42.303 63.268 42.341 70.385 30.092 84.551 30.053"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManas);
export default __webpack_public_path__ + "static/media/manas.db5bd3abadac885a140100d7a43e8692.svg";
export { ForwardRef as ReactComponent };